import React from "react";
import { Select } from "components/form-component/select/select";
import { Input } from "components/form-component/input/input";
import {
  FormStyles,
  DataStyles,
  WrapperWidth,
  FlexGrowWrapper,
  ButtonCTA,
  FormWrapper,
  LoginSpaceWrapper
} from "./user-profile-form.styles";
import { IUserProfileForm } from "./use-profile-form.types";
import { nameTitles, loginClassTypeOptions } from "constants/constants";
import { MobileInput } from "components/form-component/mobile-input/mobile-input";
import { useLoginParentForm } from "./hooks/use-login-parent-form";
import { LoginSuccessModal } from "./login-success-modal";
import useClassOptionsChange from "./hooks/use-class-options-change";

const LoginParentForm = ({ userType }: IUserProfileForm): JSX.Element => {
  const {
    control,
    getValues,
    handleSubmit,
    isValid,
    onSubmit,
    isSuccessModalOpen,
    setIsSuccessModalOpen,
    isLoading
  } = useLoginParentForm(userType);

  const { gradeOptions, handleClassOptionsChange } =
    useClassOptionsChange(getValues);

  const headerMessage = {
    primaryText: "Profil anak berhasil dibuat.",
    secondaryText: "Ayo, dukung anak belajar di CoLearn"
  };

  return (
    <FormWrapper onSubmit={handleSubmit(onSubmit)}>
      <FormStyles>
        <DataStyles>
          <WrapperWidth width="14%">
            <Select
              testId="salutation-dropdown"
              name="salutation"
              control={control}
              label="Nama Orangtua"
              options={nameTitles}
            />
          </WrapperWidth>

          <FlexGrowWrapper>
            <Input
              data-testid="full-name-field"
              control={control}
              name="fullName"
              placeholder="Isi nama Anda di sini"
            />
          </FlexGrowWrapper>
          <WrapperWidth width="45%">
            <Input
              data-testid="student-name-field"
              name="studentName"
              label="Nama anak"
              control={control}
              placeholder="Isi nama anak Anda di sini"
            />
          </WrapperWidth>
        </DataStyles>
      </FormStyles>

      <MobileInput
        label="Nomor HP anak"
        placeholder="Isi nomor HP anak Anda di sini"
        control={control}
        name="studentNumber"
      />

      <DataStyles>
        <WrapperWidth width="60%">
          <Select
            name="classType"
            testId="class-type-dropdown"
            control={control}
            label="Jenjang sekolah"
            options={loginClassTypeOptions}
            placeholder="Pilih jenjang sekolah"
            onChange={handleClassOptionsChange}
          />
        </WrapperWidth>

        <WrapperWidth width="40%">
          <Select
            testId="grade-dropdown"
            name="grade"
            control={control}
            label="Kelas"
            options={gradeOptions}
            placeholder="Pilih kelas"
          />
        </WrapperWidth>
      </DataStyles>
      <Input
        data-testid="email-field"
        name="email"
        label="Email"
        control={control}
        placeholder="Ketik alamat email di sini"
      />

      <LoginSpaceWrapper>
        <ButtonCTA
          disabled={!isValid}
          type="submit"
          variant="primary"
          isLoading={isLoading}
          loadingText={"Membuat profil"}
          data-testid="register-profile-button">
          Buat profil
        </ButtonCTA>
      </LoginSpaceWrapper>
      <LoginSuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
        headerMessage={headerMessage}
      />
    </FormWrapper>
  );
};

export { LoginParentForm };
